import { render, staticRenderFns } from "./AwardsSinglePhotoAlbum.vue?vue&type=template&id=ce785e66"
import script from "./AwardsSinglePhotoAlbum.vue?vue&type=script&lang=js"
export * from "./AwardsSinglePhotoAlbum.vue?vue&type=script&lang=js"
import style0 from "./AwardsSinglePhotoAlbum.vue?vue&type=style&index=0&id=ce785e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports